import React, { useEffect, useState } from 'react';
import Table from '../../../components/table';
import { useAdvanceBoolean, useBoolean, useWealthlaneCustomerApi } from '../../../hooks';
import { ModalStatusType, TableParamsType } from '../../../types/common';
import InitialValuesForm from '../../../constants/initialValues';
import { PageHeader } from '../../../constants/style/common.styled';
import Heading from '../../../components/typography';
import Search from '../../../components/search/search';
import { useDispatch } from 'react-redux';
import AlertPopup from '../../../components/alert-popup';
import Button from '../../../components/button';
import AnimationWrapper from '../../../components/animation/animationWrapper';
import { RoleMappingHeader } from '../../../constants/table-headers/roleMappingHeader';
import RoleMappingModal from './roleMappingModal';
import useGetAllowedRoleMapping from '../../../hooks/get/useGetAllowedRoleMapping';
import useDeleteAllowedRoleMapping from '../../../hooks/delete/useDeleteAllowedRoleMapping';
import { SettingRoleButton } from '../system-roles/systemRoleStyled';
import {
  DynamicTable,
  withDynamicTableContext,
  useDynamicTable,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import Spinners from '../../../components/spinner';
import { axiosInstance } from '../../../services/apiInterceptor';
// import CompanyMapModal from './companyMapModal';
// import useGetAllAllowedCompanyMapping from '../../../hooks/get/useGetAllowedCompanyMappings';
const initialValues = {
  data: InitialValuesForm.roleMappingModal,
  id: '',
};

const RoleMapping = () => {
  const dispatch = useDispatch();
  const { handleRequest } = useWealthlaneCustomerApi();
  // const [tableInfo, setTableInfo] = useState<TableParamsType>(InitialValuesForm.tableParams);
  const { tableInfo, setTableInfo } = useDynamicTable();

  useEffect(() => {
    setTableInfo(InitialValuesForm.tableParams);
  }, []);
  const [initialData, setInitialData] = useState(initialValues);
  const [searchQuery, setSearchQuery] = useState('');
  const [modalStatus, setModalStatus] = useState<ModalStatusType>('Edit');
  const {
    value: isConfirmOpen,
    setFalse: closeConfirmModal,
    setTrue: openConfirmModal,
  } = useBoolean(false);
  const {
    value: isModalOpen,
    setFalse: closeModal,
    setTrue: openModal,
    setCustomValue: setDeleteId,
    customValue: deleteId,
  } = useAdvanceBoolean<string>(false);

  const {
    data: roleMapping,
    isLoading,
    status,
  } = useGetAllowedRoleMapping(handleRequest, tableInfo);
  const { mutate: deleteAllowedRoleMapping, isLoading: isRoleMappingDeleting } =
    useDeleteAllowedRoleMapping(handleRequest, closeConfirmModal);

  const resetInitialData = () => setInitialData(initialValues);

  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'ROLE_MAPPING_TABLE',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });
  const data = React.useMemo(() => roleMapping?.items || [], [roleMapping, isLoading]);

  const actions = [
    {
      id: 'edit',
      action: 'Edit',
      as: 'Edit',
      onClick: (id: string, rowData: any) => {
        setModalStatus('Edit');
        setInitialData({
          data: rowData,
          id: id,
        });
        openModal();
      },
    },
    {
      id: 'delete',
      action: <div className='delete-label'>Delete</div>,
      as: 'Delete',
      onClick: (id: string) => {
        setDeleteId(id);
        openConfirmModal();
      },
    },
  ];

  const onDeleteClick = (): void => {
    deleteAllowedRoleMapping(deleteId);
  };
  const renderRightToolbarButton = () => {
    return (
      <Button
        id='createMappingButton'
        as='Create'
        variant={'primary'}
        title={'Create Mapping'}
        icon={'add_circle_outline'}
        onClick={() => {
          setModalStatus('Add');
          openModal();
        }}
      />
    );
  };

  const schema = React.useMemo(
    () => ({
      columns: RoleMappingHeader({ actions: schemaData?.columns, tableActions: actions }),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );

  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' />;

  return (
    <div data-page="roleMapping" id="roleMappingPageContainer">
      <PageHeader id="roleMappingPageHeader">
        <Heading variant='h3' title='Role Mapping' id="roleMappingPageTitle" />
        <Heading variant='body-s' title=' List of roles for mapping.' id="roleMappingPageDescription" />
      </PageHeader>
      {/* <div className='grid sm:grid-cols-12 justify-between gap-4 sm:gap-0'>
        <div className='lg:col-span-3 col-span-6'>
          <Search
            placeholder='Search'
            searchValue={searchQuery}
            onSearch={(value: string) => {
              setSearchQuery(value);
            }}
            setTableInfo={setTableInfo}
            tableInfo={tableInfo}
          />
        </div>
        <SettingRoleButton className='lg:col-start-10 lg:col-span-3 col-span-6'>
          <Button
            as='Create'
            variant={'primary'}
            title={'Create Mapping'}
            icon={'add_circle_outline'}
            onClick={() => {
              setModalStatus('Add');
              openModal();
            }}
          />
        </SettingRoleButton>
      </div> */}
      {isConfirmOpen && (
        <AlertPopup
          isShow={isConfirmOpen}
          closeModal={closeConfirmModal}
          customTitle={'Are you sure you want to delete Role Mapping?'}
          handleSubmit={onDeleteClick}
          loading={isRoleMappingDeleting}
        />
      )}
      <AnimationWrapper>
        {isModalOpen && (
          <RoleMappingModal
            id="roleMappingModal"
            isModalOpen={isModalOpen}
            closeModal={() => {
              closeModal();
              resetInitialData();
            }}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            modalLoading={false}
            initialData={initialData}
          />
        )}
      </AnimationWrapper>
      {/* <Table
        columns={RoleMappingHeader(actions)}
        data={roleMapping?.items ?? []}
        loading={status}
        showPagination={true}
        totalCounts={roleMapping?.totalCount ?? 10}
        tableInfo={tableInfo}
        setTableInfo={setTableInfo}
      /> */}
      <div id="roleMappingTableContainer">
        <DynamicTable
          id="roleMappingTable"
          schema={schema}
          data={data}
          totalCounts={roleMapping?.totalCount ?? 10}
          loading={status}
          components={{
            renderRightToolbarButton,
          }}
        />
      </div>
    </div>
  );
};

export default withDynamicTableContext(RoleMapping, false, axiosInstance);
